import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Add = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10.0002 4.5V15.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M15.4998 9.99988H4.49982" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Add;